export default __webpack_public_path__ + "static/media/Brokof-100-ml-eng.409ba1be.jpg";